export const extractIdFromSlug = (id: number | string) => {
  const numericId = typeof id !== 'number' ? parseInt(id, 10) : id
  if (isNaN(numericId)) return String(id)
  return String(numericId)
}

export const convertCentsToEuro = (amount: number) => {
  return amount / 100
}

export default {
  extractIdFromSlug,
  convertCentsToEuro,
}
